import { RoleDTO } from 'app/main/a2w/administration/roles/models/roles.model';
import { userDetail } from './user-details.model';

export class User {

    accountId: string;
    accessToken: string;
    accountImage: string;
    subTenant: string;
    apiKeyGoogleMaps: string;
    expiresIn: number;
    usuarioToken: any;
    userDetails: userDetail;
    roles: RoleDTO[];
    flagRdv: boolean;
    flagOfertaEstruturada: boolean;
    flagArmazenagem: boolean;
    moduloAtividades: boolean;
    moduloPedidos: boolean;
    visualizarOperacoesColaboradoresVinculados: boolean;


    constructor(user?) {
        user = user || {};
        
        this.accountId = user.accountId || '';
        this.accessToken = user.accessToken || '';
        this.accountImage = user.accountImage || '';
        this.subTenant = user.subTenant || '';
        this.apiKeyGoogleMaps = user.ApiKeyGoogleMaps || '';
        this.expiresIn = user.expiresIn || 0;
        this.usuarioToken = user.usuarioToken || 0; 
        this.userDetails = new userDetail(user.lastName) || new userDetail();
        this.roles = user.roles || [];
        this.flagRdv = user.flagRdv || false;
        this.flagOfertaEstruturada = user.flagOfertaEstruturada || false;
        this.flagArmazenagem = user.flagArmazenagem || false;
        this.moduloAtividades = user.moduloAtividades || false;
        this.moduloPedidos = user.moduloPedidos || false;
        this.visualizarOperacoesColaboradoresVinculados = user.visualizarOperacoesColaboradoresVinculados || false;
    }
}
